import { render, staticRenderFns } from "./ConfirmDeleteCustomerFromTo.vue?vue&type=template&id=12a8ad52&scoped=true&"
import script from "./ConfirmDeleteCustomerFromTo.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteCustomerFromTo.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDeleteCustomerFromTo.vue?vue&type=style&index=0&id=12a8ad52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a8ad52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VIcon,
  VRadio,
  VRadioGroup,
})
